import axios from "axios";
import { makeAuthorizationHeader } from "./utils.js";
import defaultAxios from "@/api/axios";
import MainStore from "@/store";
import MainRouter from "@/router";
import { TokenService } from "@/api/storage.js";

const { API_URL, API_URL_2 } = defaultAxios;

export let api = null;

export const initialize = token => {
  const instance = axios.create({
    baseURL: API_URL,
    headers: makeAuthorizationHeader(token)
  });

  api = instance;

  api.interceptors.response.use(
    config => config,
    async error => {
      if (
        error.response?.status === 401 &&
        !error.config.url.includes("token") &&
        !MainRouter.history.current.params.token
      ) {
        try {
          if (!MainStore.state.auth.runRefresh)
            await MainStore.dispatch("auth/requestRefreshToken");
          error.config.headers.Authorization = `Bearer ${TokenService.getToken()}`;
          return axios.request(error.config);
        } catch (err) {
          MainStore.dispatch("auth/logout");
          MainRouter.push({ name: "login" });
        }
      }
      // throw new Error(error);
      throw error;
    }
  );
};

export let apiPersonalData = null;

export const initializePersonalData = token => {
  const instance = axios.create({
    baseURL: API_URL_2,
    headers: makeAuthorizationHeader(token)
  });

  apiPersonalData = instance;

  apiPersonalData.interceptors.response.use(
    config => config,
    async error => {
      if (
        error.response.status === 401 &&
        !error.config.url.includes("token") &&
        !MainRouter.history.current.params.token
      ) {
        try {
          if (!MainStore.state.auth.runRefresh)
            await MainStore.dispatch("auth/requestRefreshToken");
          error.config.headers.Authorization = `Bearer ${TokenService.getToken()}`;
          return axios.request(error.config);
        } catch (err) {
          MainStore.dispatch("auth/logout");
          MainRouter.push({ name: "login" });
        }
      }
      // throw new Error(error);
      throw error;
    }
  );
};
